export default function EventStepFooter({
  ui,
  showBack,
  showNext,
  showSubmit,
  onBack,
  onNext,
  onSubmit,
  nextDisabled = false,
  submitDisabled = false,
  submissionStatus,
  reviewLocked,
  hasUnsavedChanges,
}) {
  // ----------------------------------
  // SUBMIT BUTTON LOGIC (STATUS-DRIVEN)
  // ----------------------------------
  const statusKey = String(submissionStatus || '').toLowerCase();

  const isRejected = statusKey === 'rejected';
  const isPending =
    statusKey === 'pending_review' || statusKey === 'pending';
  const isChangesRequested = statusKey === 'changes_requested';

  const isResubmitFlow = isPending || isChangesRequested;

  // undefined = new submission → do NOT block
  const changesKnownFalse = hasUnsavedChanges === false;

  let submitLabel = 'Submit';
  let computedSubmitDisabled = submitDisabled;

  if (isRejected) {
    submitLabel = 'Done';
    computedSubmitDisabled = false;
  } else if (isResubmitFlow) {
    if (changesKnownFalse) {
      submitLabel = 'Make changes to resubmit';
      computedSubmitDisabled = true;
    } else {
      submitLabel = 'Resubmit';
      computedSubmitDisabled = submitDisabled;
    }
  }

  return (
    <>
      {/* Spacer so content above doesn't hide behind fixed footer */}
      <div style={{ height: 84 }} />

      {/* Fixed footer background */}
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height: '72px',
          backgroundColor: '#fff',
          zIndex: 999,
          borderTop: '1px solid #eef0f2',
        }}
      />

      {/* Actual footer controls */}
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          display: 'flex',
          gap: 10,
          padding: '12px 16px',
          paddingBottom: '12px',
          backgroundColor: '#fff',
        }}
      >
        {showBack && (
          <button
            type="button"
            style={{
              flex: 1,
              border: '1px solid #d1d5db',
              borderRadius: 10,
              fontSize: 12,
              fontWeight: 800,
              padding: '12px 0',
              cursor: 'pointer',
              backgroundColor: '#fff',
              color: '#0b0b0b',
            }}
            onClick={onBack}
          >
            Back
          </button>
        )}

        {showNext && (
          <button
            type="button"
            onClick={onNext}
            style={{
              flex: 1,
              border: '1px solid #000',
              borderRadius: 10,
              fontSize: 12,
              fontWeight: 800,
              padding: '12px 0',
              background: '#000',
              color: '#fff',
              opacity: nextDisabled ? 0.45 : 1,
              cursor: nextDisabled ? 'not-allowed' : 'pointer',
              transition: 'opacity 120ms ease-out',
            }}
          >
            Continue
          </button>
        )}

        {showSubmit && (
  <button
    type="button"
    disabled={computedSubmitDisabled}
    onClick={() => {
      if (isRejected) {
        // Done → exit review flow
        window.location.href = '/host';
        return;
      }

      onSubmit();
    }}
    style={{
      flex: 1,
      border: '1px solid',
      borderColor: computedSubmitDisabled ? '#bdbdbd' : '#000',
      borderRadius: 10,
      fontSize: 12,
      fontWeight: 800,
      padding: '12px 0',
      cursor: computedSubmitDisabled ? 'not-allowed' : 'pointer',
      background: computedSubmitDisabled ? '#bdbdbd' : '#000',
      color: '#fff',
    }}
  >
    {submitLabel}
  </button>
)}

      </div>
    </>
  );
}
